import constants from "../constants";

const { FETCH_USER_DONE } = constants;

export default function user(state = null, action) {
  switch (action.type) {
    case FETCH_USER_DONE: {
      return { ...action.data };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./assets/shared/reducers/user.js